export default __webpack_public_path__ + "8a4e28c8eb0b9220a186d1f4a50b6271.png";